import fetchApi from "../fetchApi";
export const ExportCombineCards = async ({
  dateFrom = "",
  dateTo = "",
  ids=""
}) => {
  const options = {
    method: "POST",
    headers: new Headers({
      Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({
      ids,
      created_on_gte: dateFrom,
      created_on_lte: dateTo,
    }),
    redirect: "follow",
  };

  return await fetchApi(`card-issuing/sell-order/combine/report-csv`, options);
};